import { render, staticRenderFns } from "./DonationSuggestions.vue?vue&type=template&id=acaa6890&scoped=true"
import script from "./DonationSuggestions.vue?vue&type=script&lang=js"
export * from "./DonationSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa6890",
  null
  
)

export default component.exports